import { type MRT_ColumnDef } from "material-react-table";
import { useMemo} from "react";

import {
  SampleTable,
  SingleButton,
} from "@/shared/components/ui";

import { Grid } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useFetchPaymentMethods } from "@/shared/actions/erp";
import {Compra} from "@/shared/interfaces";
import { emptyCellOneLevel, useTableFilter } from "@/shared";
import { CompraRetencionKey, useCompraRetencionUtilizadosStore } from "@/store/erp/retencion-compra/retencion-compra-store";


export interface RetencionComprasDBDynamicTableProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const CompraRetencionDynamicTable: React.FC<
RetencionComprasDBDynamicTableProps
> = ({ open, setOpen }) => {
  //* local state

  ////* global state
  const addCompraRetencion = useCompraRetencionUtilizadosStore(
    (s) => s.addRetencionComprasPago
  );

  const productosContratados = useCompraRetencionUtilizadosStore(
    (s) => s.compraRetencion
  );

  ///* table
  const {  pagination, searchTerm } =
    useTableFilter();
  const { pageIndex } = pagination;


 
  ///* fetch data
  const {
    data: paymentMethodsRes,
   } = useFetchPaymentMethods(pageIndex + 1, searchTerm);

  const filteredCompraRetencion = useMemo(() => {
    if (!searchTerm) return paymentMethodsRes?.data?.data;

    return paymentMethodsRes?.data?.data.filter((item) =>
      item.nombre?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [paymentMethodsRes, searchTerm]);
  

  useMemo<Compra[]>(() => productosContratados, [productosContratados]);
  const columnsCompraRetencion: MRT_ColumnDef<Compra>[] = useMemo<
    MRT_ColumnDef<Compra>[]
  >(
    () => [
      {
        accessorKey: "actions",
        header: "Acciones",
        Cell: ({ row }) => {
          return (
            <SingleButton
              newCustomButton
              label="AGREGAR"
              variant="text"
              color="success"
              showIcon={false}
              onClick={() => {
                addCompraRetencion(
                  row.original,
                  CompraRetencionKey.compraRetencion
                );
              }}
            />
          );
        },
      },
      {
        accessorKey:"codigo",
        header: "Codigo",
        size: 300,
      },
      {
        accessorKey: "fecha_emision",
        header: "fecha de emision",
        size: 300,
      },
      {
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 300,
      },
        {
          accessorKey: "proveedor_data.razon_social",
          header: "proveedor",
          size: 300,
        }, 
        {
          accessorKey: "ubicacion_data.nombre",
          header: "ubicación",
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, "ubicacion"),
        },
        {
          accessorKey: "numero_autorizacion",
          header: "numero de autorizacion",
          size: 300,
        },  
    ],
    [addCompraRetencion]
  );
  return (
    <ScrollableDialogProps
      open={open}
      title="Formas de pago"
      cancelTextBtn="Cerrar"
      // actions
      onClose={() => setOpen(false)}
      // content
      minWidth="60%"
      contentNode={
        <>
          <Grid container spacing={3}>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <SampleTable<any>
      columns={columnsCompraRetencion as any}
      data={filteredCompraRetencion || []}
    />
  </Grid>
</Grid>
        </>
      }
    />
  );
};
export default CompraRetencionDynamicTable;
